/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Move_Word_DownInputs */



/**
* | output |
* | --- |
* | "Move Word Down" |
*
* @param {Shortcut_Keys_Name_Move_Word_DownInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_move_word_down = /** @type {((inputs?: Shortcut_Keys_Name_Move_Word_DownInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Move_Word_DownInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Deplacer un mot vers le bas")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wort nach unten verschieben")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sposta la parola verso il basso")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сдвинуть слово вниз")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mover palabra hacia abajo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("向下移动单词")
	if (locale === "ja") return /** @type {LocalizedString} */ ("単語を下に移動")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शब्द को नीचे ले जाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mova a palavra para baixo.")
	return /** @type {LocalizedString} */ ("Move Word Down")
});